<div class="bg-surface-medium-emphasis wrap position-relative w-100 mx-auto my-0 px-5 font-m">
    <div class="content my-4" *ngIf="isExpanded">
        <h3 class="title d-flex">{{ title }}</h3>
        <div class="description"><ng-content></ng-content></div>
    </div>
</div>
